import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Search } from 'lucide-react';
import Layout from '../components/layout/Layout';
import SEO from '../components/seo/SEO';
import { Button } from '../components/ui/button';
import { BRAND_NAME } from '../lib/brand';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO
        title={`${BRAND_NAME} | Sayfa Bulunamadı`}
        description={`Aradığınız sayfa bulunamadı. ${BRAND_NAME} ana sayfasına dönün.`}
      />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <div className="mb-8">
          <h1 className="text-6xl sm:text-8xl font-bold text-gray-200 mb-4">404</h1>
          <h2 className="text-2xl sm:text-3xl font-semibold mb-4">Sayfa Bulunamadı</h2>
          <p className="text-gray-600 text-lg mb-8">
            Aradığınız sayfa mevcut değil veya taşınmış olabilir.
          </p>
        </div>

        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button size="lg" className="w-full sm:w-auto">
                <Home size={18} className="mr-2" />
                Ana Sayfaya Dön
              </Button>
            </Link>
            <Link to="/">
              <Button size="lg" variant="outline" className="w-full sm:w-auto">
                <Search size={18} className="mr-2" />
                Ürün Ara
              </Button>
            </Link>
          </div>

          <div className="pt-8 border-t">
            <p className="text-gray-500 text-sm mb-4">Popüler Kategoriler:</p>
            <div className="flex flex-wrap gap-2 justify-center">
              <Link
                to="/category/kadin"
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm transition-colors"
              >
                Kadın
              </Link>
              <Link
                to="/category/erkek"
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm transition-colors"
              >
                Erkek
              </Link>
              <Link
                to="/category/cocuk"
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm transition-colors"
              >
                Çocuk
              </Link>
              <Link
                to="/sale"
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm transition-colors"
              >
                İndirimli Ürünler
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
